import { Outlet, createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { z } from 'zod'
import { AppLoader } from '~/components/loader'
import { useSessionRefresher } from '~/features/auth'
import { LinkButton, LinkButtonHref } from '~/features/navigation'
import { useCurrentUser } from '~/hooks'
import { ErrorBoundary, PageLevelError } from '~/modules/error-boundary'
import { Nav } from '~/templates/main'
import { PublicTemplate } from '~/templates/public'

import { Heading1, Icon } from '@hap/components'

const searchParamsSchema = z.object({
  qid: z.string().optional(),
  ieq: z.string().optional(),
  p: z.number().optional(),
  r: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/$alias/_app')({
  component: RouteComponent,
  validateSearch: searchParamsSchema,
})

function RouteComponent() {
  useSessionRefresher()
  const currentUser = useCurrentUser()
  if (!currentUser) return <AppLoader />

  if (currentUser.permissions.length === 0) {
    return (
      <PublicTemplate>
        <div className="bg-accent flex flex-col p-10">
          <Icon name="x-circle" className="mx-auto mb-4 size-10" />
          <hgroup className="mb-10 space-y-2 text-center">
            <Heading1>Access Denied</Heading1>
            <p>
              If you think this is a mistake, please
              <br />
              contact support or your account manager.
            </p>
          </hgroup>
          <div className="grid gap-2">
            <LinkButtonHref href="mailto:help@happitu.com">
              Contact Support
            </LinkButtonHref>
            <LinkButton to="/logout" variant="ghost">
              Log out
            </LinkButton>
          </div>
        </div>
      </PublicTemplate>
    )
  }

  return (
    <>
      <Nav />
      <Suspense fallback={<AppLoader />}>
        <ErrorBoundary errorComponent={<PageLevelError />}>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
    </>
  )
}
